import type { TenantConfig } from '@/types/TenantConfig'

export const mitmuseum: TenantConfig = {
  logo: 'assets/mitmuseum/static/logo.svg',
  themeOptions: {
    logoHeight: '75px',
    headerHeight: '105px',
    primaryColor: '#0091ff',
    secondaryColor: '#ff40b6',
    pageBackgroundColor: '#ededed',
    headerBackground: '#ededed',
    footerBackgroundColor: '#484848',
    footerTextColor: '#ffffff',
    cartHeaderBackgroundColor: '#484848',
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/mitmuseum/static/completed.png',
      },
      completedContentOffset: {
        desktop: '-150px',
        mobile: '-100px',
      },
    },
  },
  teaserImageSize: {
    width: 320,
  },
}
